import { default as Loading } from './Loading';

export { default as LoadingFixed } from './Fixed';
export { default as LoadingInterface } from './Interface';
export { default as LoadingPage } from './Page';
export { default as LoadingSpinner } from './Spinner';

export default Loading;
